(() => {
  'use strict';
  const countryCurrencies = {"AC":"SHP","AD":"EUR","AE":"AED","AF":"AFN","AG":"XCD","AI":"XCD","AL":"ALL","AM":"AMD","AO":"AOA","AR":"ARS","AS":"USD","AT":"EUR","AU":"AUD","AW":"AWG","AX":"EUR","AZ":"AZN","BA":"BAM","BB":"BBD","BD":"BDT","BE":"EUR","BF":"XOF","BG":"EUR","BH":"BHD","BI":"BIF","BJ":"XOF","BL":"EUR","BM":"BMD","BN":"BND","BO":"BOB","BQ":"USD","BR":"BRL","BS":"BSD","BT":"BTN","BV":"NOK","BW":"BWP","BY":"BYN","BZ":"BZD","CA":"CAD","CC":"AUD","CD":"CDF","CF":"XAF","CG":"XAF","CH":"CHF","CI":"XOF","CK":"NZD","CL":"CLP","CM":"XAF","CN":"CNY","CO":"COP","CR":"CRC","CU":"CUP","CV":"CVE","CW":"XCG","CX":"AUD","CY":"EUR","CZ":"CZK","DE":"EUR","DG":"USD","DJ":"DJF","DK":"DKK","DM":"XCD","DO":"DOP","DZ":"DZD","EA":"EUR","EC":"USD","EE":"EUR","EG":"EGP","EH":"MAD","ER":"ERN","ES":"EUR","ET":"ETB","EU":"EUR","FI":"EUR","FJ":"FJD","FK":"FKP","FM":"USD","FO":"DKK","FR":"EUR","GA":"XAF","GB":"GBP","GD":"XCD","GE":"GEL","GF":"EUR","GG":"GBP","GH":"GHS","GI":"GIP","GL":"DKK","GM":"GMD","GN":"GNF","GP":"EUR","GQ":"XAF","GR":"EUR","GS":"GBP","GT":"GTQ","GU":"USD","GW":"XOF","GY":"GYD","HK":"HKD","HM":"AUD","HN":"HNL","HR":"EUR","HT":"HTG","HU":"HUF","IC":"EUR","ID":"IDR","IE":"EUR","IL":"ILS","IM":"GBP","IN":"INR","IO":"USD","IQ":"IQD","IR":"IRR","IS":"ISK","IT":"EUR","JE":"GBP","JM":"JMD","JO":"JOD","JP":"JPY","KE":"KES","KG":"KGS","KH":"KHR","KI":"AUD","KM":"KMF","KN":"XCD","KP":"KPW","KR":"KRW","KW":"KWD","KY":"KYD","KZ":"KZT","LA":"LAK","LB":"LBP","LC":"XCD","LI":"CHF","LK":"LKR","LR":"LRD","LS":"LSL","LT":"EUR","LU":"EUR","LV":"EUR","LY":"LYD","MA":"MAD","MC":"EUR","MD":"MDL","ME":"EUR","MF":"EUR","MG":"MGA","MH":"USD","MK":"MKD","ML":"XOF","MM":"MMK","MN":"MNT","MO":"MOP","MP":"USD","MQ":"EUR","MR":"MRU","MS":"XCD","MT":"EUR","MU":"MUR","MV":"MVR","MW":"MWK","MX":"MXN","MY":"MYR","MZ":"MZN","NA":"NAD","NC":"XPF","NE":"XOF","NF":"AUD","NG":"NGN","NI":"NIO","NL":"EUR","NO":"NOK","NP":"NPR","NR":"AUD","NU":"NZD","NZ":"NZD","OM":"OMR","PA":"PAB","PE":"PEN","PF":"XPF","PG":"PGK","PH":"PHP","PK":"PKR","PL":"PLN","PM":"EUR","PN":"NZD","PR":"USD","PS":"ILS","PT":"EUR","PW":"USD","PY":"PYG","QA":"QAR","RE":"EUR","RO":"RON","RS":"RSD","RU":"RUB","RW":"RWF","SA":"SAR","SB":"SBD","SC":"SCR","SD":"SDG","SE":"SEK","SG":"SGD","SH":"SHP","SI":"EUR","SJ":"NOK","SK":"EUR","SL":"SLE","SM":"EUR","SN":"XOF","SO":"SOS","SR":"SRD","SS":"SSP","ST":"STN","SV":"USD","SX":"XCG","SY":"SYP","SZ":"SZL","TA":"GBP","TC":"USD","TD":"XAF","TF":"EUR","TG":"XOF","TH":"THB","TJ":"TJS","TK":"NZD","TL":"USD","TM":"TMT","TN":"TND","TO":"TOP","TR":"TRY","TT":"TTD","TV":"AUD","TW":"TWD","TZ":"TZS","UA":"UAH","UG":"UGX","UM":"USD","US":"USD","UY":"UYU","UZ":"UZS","VA":"EUR","VC":"XCD","VE":"VES","VG":"USD","VI":"USD","VN":"VND","VU":"VUV","WF":"XPF","WS":"WST","XK":"EUR","YE":"YER","YT":"EUR","ZA":"ZAR","ZM":"ZMW","ZW":"ZWG"};
  const init = () => {
    const config = document.querySelector('[data-rc-config]');
    if (!config || window.RassmeCurrency) return;
    const base = config.dataset.base;
    if (!/^[A-Z]{3}$/.test(base)) return;
    const language = document.documentElement.lang || 'en';
    const offeredCurrencies = new Set([base, ...Object.values(countryCurrencies)]);
    const day = 86400000;
    const keys = {preference: 'rassme:currency:v1', geo: 'rassme:country:v1', rates: `rassme:rates:v1:${base}`, retry: `rassme:rates-retry:v1:${base}`};
    const read = (storage, key) => { try { return JSON.parse(window[storage].getItem(key)); } catch { return null; } };
    const write = (storage, key, value) => { try { window[storage].setItem(key, JSON.stringify(value)); } catch {} };
    const cachedPreference = read('localStorage', keys.preference);
    let preference = cachedPreference && /^[A-Z]{3}$/.test(cachedPreference.currency) && Date.now() - cachedPreference.time < 90 * day ? cachedPreference : null;
    let mode = preference ? 'manual' : 'auto';
    let selected = base;
    let geoCountry = '';
    let rates = {[base]: 1};
    let rateData = null;
    let rateError = false;
    let geoError = false;
    let ratePromise;
    let geoPromise;
    let choiceVersion = 0;
    let loading = true;
    const formatters = new Map();
    const common = ['USD', 'JOD', 'SAR', 'AED', 'EUR', 'GBP', 'KWD', 'QAR', 'BHD', 'OMR', 'CAD', 'AUD'];
    let currencyNames;
    let regionNames;
    try { currencyNames = new Intl.DisplayNames([language], {type: 'currency'}); regionNames = new Intl.DisplayNames([language], {type: 'region'}); } catch {}
    const controls = selector => document.querySelectorAll(selector);
    const safeCode = code => typeof code === 'string' && Object.hasOwn(rates, code) && Number.isFinite(rates[code]) && rates[code] > 0;
    const fetchJSON = async (url, sameOrigin = false) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 6500);
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: sameOrigin ? 'same-origin' : 'omit', referrerPolicy: sameOrigin ? 'strict-origin-when-cross-origin' : 'no-referrer'});
        if (!response.ok) throw new Error('Unavailable');
        return await response.json();
      } finally { clearTimeout(timer); }
    };
    const acceptRates = data => {
      if (!data || data.result !== 'success' || data.base_code !== base || !data.rates || data.rates[base] !== 1) return false;
      const stamp = Number(data.time_last_update_unix) * 1000;
      if (!Number.isFinite(stamp) || stamp > Date.now() + day || Date.now() - stamp > 3 * day) return false;
      const clean = Object.fromEntries(Object.entries(data.rates).filter(([code, value]) => offeredCurrencies.has(code) && /^[A-Z]{3}$/.test(code) && typeof value === 'number' && Number.isFinite(value) && value > 0));
      if (Object.keys(clean).length < 10) return false;
      rates = clean;
      rateData = data;
      return true;
    };
    const loadRates = () => {
      if (ratePromise) return ratePromise;
      ratePromise = (async () => {
        const cached = read('localStorage', keys.rates);
        const accepted = acceptRates(cached?.data);
        if (accepted && cached.fetched <= Date.now() && Date.now() - cached.fetched < day) return;
        const retry = read('localStorage', keys.retry);
        if (retry && retry <= Date.now() && Date.now() - retry < 3600000) { rateError = true; return; }
        write('localStorage', keys.retry, Date.now());
        try {
          const data = await fetchJSON(`https://open.er-api.com/v6/latest/${base}`);
          if (!acceptRates(data)) throw new Error('Invalid rates');
          rateError = false;
          write('localStorage', keys.rates, {fetched: Date.now(), data});
        } catch { rateError = true; }
      })();
      return ratePromise;
    };
    const loadCountry = () => {
      if (geoPromise) return geoPromise;
      geoPromise = (async () => {
        const cached = read('sessionStorage', keys.geo);
        if (cached && /^[A-Z]{2}$/.test(cached.country) && Date.now() - cached.time < 21600000) { geoCountry = cached.country; return; }
        try {
          const rootPath = config.dataset.root.replace(/\/?$/, '/');
          const url = new URL(`${rootPath}browsing_context_suggestions.json`, location.origin);
          url.searchParams.set('country[enabled]', 'true');
          const data = await fetchJSON(url.href, true);
          const detected = data.detected_values?.country?.handle;
          if (!/^[A-Z]{2}$/.test(detected || '')) throw new Error('Unknown country');
          geoCountry = detected;
          write('sessionStorage', keys.geo, {country: detected, time: Date.now()});
        } catch { geoError = true; }
      })();
      return geoPromise;
    };
    const format = minor => {
      if (!formatters.has(selected)) formatters.set(selected, new Intl.NumberFormat(language, {style: 'currency', currency: selected, currencyDisplay: 'code', minimumFractionDigits: 0, maximumFractionDigits: 1}));
      const halfUnits = minor / 100 * rates[selected] * 2;
      const tolerance = Number.EPSILON * Math.max(1, Math.abs(halfUnits)) * 4;
      const rounded = Math.ceil(halfUnits - tolerance) / 2;
      return formatters.get(selected).format(rounded === 0 ? 0 : rounded);
    };
    const renderPrice = element => {
      const raw = element.getAttribute('data-rassme-money');
      if (raw === null || !/^-?\d+$/.test(raw)) return;
      const minor = Number(raw);
      if (!Number.isSafeInteger(minor)) return;
      const text = format(minor);
      if (element.textContent !== text) element.textContent = text;
      if (selected !== base) element.title = config.dataset.estimate;
      else element.removeAttribute('title');
    };
    const prepareRecommendations = root => {
      if (base !== config.dataset.shopCurrency) return;
      const selector = '.limespot-recommendation-box-item[data-price]';
      const items = [...root.querySelectorAll(selector)];
      const nearest = root.closest?.(selector);
      if (nearest) items.push(nearest);
      items.forEach(item => {
        [['.ls-price', 'data-price'], ['.ls-original-price', 'data-original-price']].forEach(([selector, attribute]) => {
          const node = item.querySelector(selector);
          const raw = item.getAttribute(attribute);
          if (!node || !raw || !/^\d+(\.\d+)?$/.test(raw)) return;
          const minor = Math.round(Number(raw) * 100);
          if (!Number.isSafeInteger(minor)) return;
          node.classList.remove('money');
          node.removeAttribute('data-money-convertible');
          node.removeAttribute('data-current-currency');
          if (node.getAttribute('data-rassme-money') !== String(minor)) node.setAttribute('data-rassme-money', String(minor));
          renderPrice(node);
        });
      });
    };
    const refresh = (root = document) => {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      prepareRecommendations(root);
      if (root.matches?.('[data-rassme-money]')) renderPrice(root);
      root.querySelectorAll('[data-rassme-money]').forEach(renderPrice);
    };
    const status = () => {
      if (loading) return config.dataset.loading;
      if (!rateData && rateError) return config.dataset.unavailable;
      if (rateError) return config.dataset.cached;
      if (mode === 'manual' && preference && selected !== preference.currency) return config.dataset.unavailable;
      if (mode === 'manual') return config.dataset.manual;
      if (geoError || !countryCurrencies[geoCountry] || !safeCode(countryCurrencies[geoCountry])) return config.dataset.unknown;
      const name = regionNames?.of(geoCountry) || geoCountry;
      return config.dataset.detected.replace('[country]', name);
    };
    const updateControls = () => {
      controls('[data-rc-code]').forEach(node => { node.textContent = selected; });
      controls('[data-rc-select]').forEach(select => {
        const codes = common.filter(safeCode);
        const outsideList = !codes.includes(selected);
        const signature = `${codes.join(',')}|${outsideList}`;
        if (select.dataset.codes !== signature) {
          const options = codes.map(code => {
            const option = document.createElement('option');
            option.value = code;
            option.textContent = `${code} · ${currencyNames?.of(code) || code}`;
            return option;
          });
          if (outsideList) {
            const placeholder = document.createElement('option');
            placeholder.value = '';
            placeholder.textContent = select.closest('[data-rc-picker]')?.querySelector('label')?.textContent || '';
            placeholder.disabled = true;
            placeholder.hidden = true;
            options.unshift(placeholder);
          }
          select.replaceChildren(...options);
          select.dataset.codes = signature;
        }
        select.value = outsideList ? '' : selected;
      });
      controls('[data-rc-auto]').forEach(button => { button.setAttribute('aria-pressed', String(mode === 'auto')); });
      controls('[data-rc-status]').forEach(node => { node.textContent = status(); });
    };
    const apply = code => {
      selected = safeCode(code) ? code : base;
      refresh();
      updateControls();
      document.dispatchEvent(new CustomEvent('rassme:currency-change', {detail: {currency: selected, mode}}));
    };
    const bind = () => {
      controls('[data-rc-picker]').forEach(picker => {
        picker.hidden = false;
        if (picker.dataset.bound) return;
        picker.dataset.bound = 'true';
        picker.querySelector('[data-rc-select]')?.addEventListener('change', event => {
          choiceVersion++;
          mode = 'manual';
          preference = {currency: event.target.value, time: Date.now()};
          write('localStorage', keys.preference, preference);
          apply(preference.currency);
        });
        picker.querySelector('[data-rc-auto]')?.addEventListener('click', async () => {
          const version = ++choiceVersion;
          mode = 'auto';
          preference = null;
          write('localStorage', keys.preference, null);
          await Promise.all([loadCountry(), loadRates()]);
          if (version === choiceVersion) apply(countryCurrencies[geoCountry]);
        });
      });
      updateControls();
    };
    window.RassmeCurrency = {refresh, get currency() { return selected; }, get mode() { return mode; }};
    bind();
    const observer = new MutationObserver(records => {
      const roots = new Set();
      records.forEach(record => {
        if (record.type === 'attributes') roots.add(record.target);
        else {
          if (record.target.matches?.('[data-rassme-money],.ls-price,.ls-original-price')) roots.add(record.target);
          record.addedNodes.forEach(node => { if (node.nodeType === 1) roots.add(node); });
        }
      });
      roots.forEach(refresh);
    });
    observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-rassme-money', 'data-price', 'data-original-price']});
    document.addEventListener('shopify:section:load', event => { bind(); refresh(event.target); });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') controls('[data-rc-picker][open]').forEach(picker => { picker.open = false; picker.querySelector('summary').focus(); });
    });
    document.addEventListener('click', event => {
      controls('[data-rc-picker][open]').forEach(picker => { if (!picker.contains(event.target)) picker.open = false; });
    });
    window.addEventListener('pageshow', () => refresh());
    const version = choiceVersion;
    Promise.all([loadRates(), preference ? Promise.resolve() : loadCountry()]).then(() => {
      loading = false;
      if (version === choiceVersion) apply(mode === 'manual' ? preference?.currency : countryCurrencies[geoCountry]);
      else { updateControls(); refresh(); }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
